import { getTokenFromStorage } from "./helpers/storageUtils";

export const authMiddleware = () => {

    if((localStorage.getItem('fromWhere')==='apply_now' || sessionStorage.getItem('fromWhere')==='apply_now')|| sessionStorage.getItem('webView') || sessionStorage.getItem('mobileRequired')){
        return true;
    }else{
        let token = getTokenFromStorage();
        return (token ==='' || token ===null) ? false : true;
    }

    
    
};